import { createPartnerAdminApiStore } from '@/api'
const apiStore = createPartnerAdminApiStore([
  {
    action: '_orderList',
    path: 'v2/orders',
    method: 'get',
    cacheable: false
  }
])

const SEARCH_DATA = () => {
  return {
    beginAt:'',
    endAt:'',
    productNo: '', 
    type: ''
  }
}

const PAGE_DATA = () => {
  return {
    pageIndex: 1,
    pageCount: 30,
    format: ''
  }
}

const INIT_DATA = () => {
  return Object.assign({}, SEARCH_DATA(), PAGE_DATA())
}

export default {
  namespaced: true,
  mixins: [apiStore],
  state: {
    listParams: INIT_DATA(),
    total: 0
  },
  getters: {
    listParams: state => state.listParams
  },
  actions: {
    orderList ({state, dispatch, commit}, params) {
      if (params !== undefined) commit('SET_SEARCH_PARAMS', params)
      return dispatch('_orderList', { params: state.listParams })
    }
  },
  mutations: {
    SET_SEARCH_PARAMS (state, params) {
      state.listParams.beginAt = params.beginAt
      state.listParams.endAt = params.endAt
      state.listParams.productNo = params.productNo
      state.listParams.type = params.type
    },
    SET_PAGE_PARAMS (state, params) {
      state.listParams.pageIndex = params.pageIndex
      state.listParams.pageCount = params.pageCount
      state.listParams.format = params.format
    },
    INIT (state) {
      state.listParams = INIT_DATA()
    },
  }
}
